import React, { Component } from 'react'
import styles from './PlayButton.css'

export default class PlayButton extends Component {
  render () {
    return (
      <div className={styles.playButton}/>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Rist/modules/PlayButton/index.js